export class Client {
  id: string;
  clientId: string;
  clientName: string;
  clientFullName: string;
  can: string;
  date: string;
  modifiedBy: string;
  clientSites: ClientSite[] = new Array<ClientSite>();
}

export class ClientSite {
  id: string;
  siteName: string;
  siteAddress: string;
}
